import React, { useCallback } from 'react';
import classes from './style.module.scss';
import Button from 'app/common/Button/index';
import useTranslation from 'app/hooks/useTranslation';
import useForm from "~/app/modules/form/useForm";
import { ServiceClosePayload, APIResponse, ServiceDetails } from "~/types";
import { useStoreActions, useStoreState } from "~/store";
import { notify } from '~/app/helpers/notify';
import useWebSocket from '~/app/hooks/useWebSocket';

export interface FooterProps {
    onClose: () => void
    serviceDetails: ServiceDetails
    onSave?: (id: ServiceDetails['id']) => void
}

export type FooterComponent = React.FC<FooterProps>;

const Footer: FooterComponent = ({ onClose, serviceDetails, onSave }) => {
    const { t } = useTranslation('service');
    const { t: tIssue } = useTranslation('issue');
    const { values: formValues, formEvents: { onSubmit } } = useForm<ServiceClosePayload>({ formName: 'closeService' });
    const closeServiceAction = useStoreActions(actions => actions.service.closeService);
    const fetching = useStoreState(state => state.service.fetching);
    const netWorkStatus = useStoreState(state => state.app.offline.status);
    const { syncDeletedService } = useWebSocket();
    const serviceId = serviceDetails.id;
    const departmentId = serviceDetails.departmentId;
    const checksData = useStoreState(state => state.serviceCheck.checksData);

    const saveClickHandler = useCallback((): void => {
        onSubmit(({ formState: { invalid } }) => {
            if (invalid) {
                return;
            }
            const payload: ServiceClosePayload = {
                ...formValues,
                ...(serviceId && { serviceId }),
                checklist: checksData
            } as ServiceClosePayload;

            closeServiceAction(payload).then(async (data: APIResponse) => {
                onClose();
                if (data.success && serviceId) {
                    onSave?.(serviceId);
                    notify(t(`success.closed`), 'success');
                } else {
                    notify(tIssue(`error.${data?.msg}`), 'error');
                }

                if (netWorkStatus === 0) {
                    syncDeletedService({ serviceId: serviceId, departmentId: departmentId });
                }
            });
        })();
    }, [formValues, onSubmit, serviceId, closeServiceAction, t, tIssue, onClose, onSave, netWorkStatus, syncDeletedService, departmentId, checksData]);

    return (
        <div className={`${classes['footer']}`}>
            <Button
                className={classes['abort']}
                onClick={onClose}>{t('cancel')}</Button>
            <Button
                className={classes['submit']}
                loading={fetching}
                onClick={saveClickHandler}>{t('serviceClose.complete')}</Button>
        </div>
    );
};

export default Footer
